import React, { useContext } from "react";
import { UserContext } from "../context/userContext";
import { useNavigate } from "react-router-dom";
import logoKmayra from "../../assets/logoWBG.png";
import "./index.scss";

function ModalMenu({
  setIsOpen = (args: boolean) => {},
  setIsOpenDisconnect = (args: boolean) => {},
  page = "",
}: any) {
  const { user, isAuthenticated } = useContext(UserContext);
  const navigate = useNavigate();

  const goTo = (path: string) => {
    navigate(path);
    setIsOpen(false);
  };

  return (
    <div className="modal-menu-container">
      {/* HEADER */}
      <div className="menu-header">
        <img src={logoKmayra} alt="Mhiri Logo" className="menu-logo" />

        <div className="menu-close-icon" onClick={() => setIsOpen(false)}>
          <i className="bx bx-x" style={{ fontSize: 26 }}></i>
        </div>
      </div>

      {/* OPTIONS */}
      <div className="menu-options">
        {user?.role === 1 && (
          <button
            className={`nav-button ${
              page === "dashboard" ? "nav-button-active" : ""
            }`}
            onClick={() => goTo("/dashboard-admin")}
          >
            Dashboard <i className="bx bxs-dashboard"></i>
          </button>
        )}

        <button
          className={`nav-button ${
            page === "acceuil" ? "nav-button-active" : ""
          }`}
          onClick={() => goTo("/acceuil")}
        >
          Acceuil <i className="bx bx-home"></i>
        </button>

        <button
          className={`nav-button ${page === "card" ? "nav-button-active" : ""}`}
          onClick={() => goTo("/card")}
        >
          Basket <i className="bx bx-basket"></i>
        </button>

        <button
          className={`nav-button ${page === "shop" ? "nav-button-active" : ""}`}
          onClick={() => goTo("/shop")}
        >
          Shop <i className="bx bxs-shopping-bag"></i>
        </button>

        {isAuthenticated && (
          <button
            className={`nav-button ${
              page === "profile" ? "nav-button-active" : ""
            }`}
            onClick={() => goTo("/profile")}
          >
            Profile <i className="bx bxs-user-account"></i>
          </button>
        )}

        {isAuthenticated ? (
          <button
            className="nav-button nav-button-danger"
            onClick={() => {
              setIsOpen(false);
              setIsOpenDisconnect(true);
            }}
          >
            Logout <i className="bx bx-log-out"></i>
          </button>
        ) : (
          <button className="nav-button" onClick={() => goTo("/login")}>
            Login <i className="bx bx-log-in"></i>
          </button>
        )}
      </div>
    </div>
  );
}

export default ModalMenu;
